import { IApplicationState, TCardId } from 'app/types/types';

export const getPushToGoogleCalendarCardId = (
    state: IApplicationState
): TCardId => {
    return state.pushToGoogleCalendar.cardId;
};
